<template>
    <div class="container-fluid" style="padding:0;">
        <tab></tab>
        <div class="row">
            <div class="activity-top" :class="{ 'hidden-xs hidden-sm': isShowWeb }">
                <img :src="`${pageUrl.imgUrl}${pageInfo.pic}`" alt="#" class="inner-item-img" />
                <div class="activity-top-font">
                    <div class="top-font-font">{{ lanType == 1 ? pageInfo.title : pageInfo.titleEn }}</div>
                </div>
            </div>

            <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
                <img :src="`${pageUrl.imgUrl}${pageInfo.pic}`" alt="#" class="phone-inner-img" />
                <div class="activity-top-font">
                    <div class="phone-font-font">{{ lanType == 1 ? pageInfo.title : pageInfo.titleEn }}</div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="web-row row" :class="{ 'hidden-xs hidden-sm': isShowWeb }">
                <!--  pc端  -->

                <div class="dynamic-center-list" v-if="sfsList.length">
                    <div class="center-list-top spaceBetween">
                        <div class="list-top-left start">
                            <div class="top-left-label bg4"></div>
                            <span>{{lanType==1?'可持续燃料':'Sustainable Fuels'}}</span>
                        </div>

                        <div class="list-top-right end">
                            <div class="top-right-btn middle bg4" @click="goDynamicList(4)" v-if="sfsList.length>4">
                                <span class="right-btn-font">{{lanType==1? '查看更多' : 'See more'}}</span>
                                <img src="@/images/rights.png" alt="#" class="right-btn-icon">
                            </div>
                        </div>
                    </div>

                    <div class="center-list-center spaceBetween wrap">
                        <div class="list-center-li spaceBetween" @click="goMechanism(item)" v-for="(item,index) in sfsList" :key="index" v-if="index<4">
                            <div class="center-li-left">
                                <img :src='item.picStr' alt="#" class="center-li-img">
                                <div class="li-left-btns start wrap">
                                    <div class="left-btns-btn bg1" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                                    <div class="left-btns-btn bg2" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                                </div>
                            </div>
                            <div class="center-li-right columnBetween">
                                <div class="li-right-title">{{lanType==1?item.title:item.titleEn}}</div>

                                

                                <div class="li-right-bottom spaceBetween">
                                    <div class="right-bottom-time">{{item.release_date}}</div>
                                    <div class="right-bottom-tips color1">{{lanType==1?'查看详情':'View details'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dynamic-center-list" v-if="csList.length">
                    <div class="center-list-top spaceBetween">
                        <div class="list-top-left start">
                            <div class="top-left-label bg3"></div>
                            <span>{{lanType==1?'气候创行者':'Climate Solver'}}</span>
                        </div>

                        <div class="list-top-right end">
                            <div class="top-right-btn middle bg3" @click="goDynamicList(3)" v-if="csList.length>4">
                                <span class="right-btn-font">{{lanType==1? '查看更多' : 'See more'}}</span>
                                <img src="@/images/rights.png" alt="#" class="right-btn-icon">
                            </div>
                        </div>
                    </div>

                    <div class="center-list-center spaceBetween wrap">
                        <div class="list-center-li spaceBetween" @click="goMechanism(item)" v-for="(item,index) in csList" :key="index" v-if="index<4">
                            <div class="center-li-left">
                                <img :src='item.picStr' alt="#" class="center-li-img">
                                <div class="li-left-btns start wrap">
                                    <div class="left-btns-btn bg1" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                                    <div class="left-btns-btn bg2" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                                </div>
                            </div>
                            <div class="center-li-right columnBetween">
                                <div class="li-right-title">{{lanType==1?item.title:item.titleEn}}</div>

                                

                                <div class="li-right-bottom spaceBetween">
                                    <div class="right-bottom-time">{{item.release_date}}</div>
                                    <div class="right-bottom-tips color1">{{lanType==1?'查看详情':'View details'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dynamic-center-list" v-if="sbtiList.length">
                    <div class="center-list-top spaceBetween">
                        <div class="list-top-left start">
                            <div class="top-left-label bg1"></div>
                            <span>{{lanType==1?'SBTi科学碳目标':'Science Based Target initiative (SBTi)'}}</span>
                        </div>

                        <div class="list-top-right end">
                            <div class="top-right-btn middle bg1" @click="goDynamicList(1)" v-if="sbtiList.length>4">
                                <span class="right-btn-font">{{lanType==1? '查看更多' : 'See more'}}</span>
                                <img src="@/images/rights.png" alt="#" class="right-btn-icon">
                            </div>
                        </div>
                    </div>

                    <div class="center-list-center spaceBetween wrap">
                        <div class="list-center-li spaceBetween" @click="goMechanism(item)" v-for="(item,index) in sbtiList" :key="index" v-if="index<4">
                            <div class="center-li-left">
                                <img :src='item.picStr' alt="#" class="center-li-img">
                                <div class="li-left-btns start wrap">
                                    <div class="left-btns-btn bg1" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                                    <div class="left-btns-btn bg2" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                                </div>
                            </div>
                            <div class="center-li-right columnBetween">
                                <div class="li-right-title">{{lanType==1?item.title:item.titleEn}}</div>

                                

                                <div class="li-right-bottom spaceBetween">
                                    <div class="right-bottom-time">{{item.release_date}}</div>
                                    <div class="right-bottom-tips color1">{{lanType==1?'查看详情':'View details'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="dynamic-center-list" v-if="rebpList.length">
                    <div class="center-list-top spaceBetween">
                        <div class="list-top-left start">
                            <div class="top-left-label bg2"></div>
                            <span>{{lanType==1 ? '绿色电力需求' : "Renewable Energy Buyers' Principles"}}</span>
                        </div>

                        <div class="list-top-right end">
                            <div class="top-right-btn middle bg2" @click="goDynamicList(2)" v-if="rebpList.length>4">
                                <span class="right-btn-font">{{lanType==1? '查看更多' : 'See more'}}</span>
                                <img src="@/images/rights.png" alt="#" class="right-btn-icon">
                            </div>
                        </div>
                    </div>

                    <div class="center-list-center spaceBetween wrap">
                        <div class="list-center-li spaceBetween" @click="goMechanism(item)" v-for="(item,index) in rebpList" :key="index" v-if="index<4">
                            <div class="center-li-left">
                                <img :src='item.picStr' alt="#" class="center-li-img">
                                <div class="li-left-btns start wrap">
                                    <div class="left-btns-btn bg1" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                                    <div class="left-btns-btn bg2" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                                </div>
                            </div>
                            <div class="center-li-right columnBetween">
                                <div class="li-right-title">{{lanType==1?item.title:item.titleEn}}</div>

                                

                                <div class="li-right-bottom spaceBetween">
                                    <div class="right-bottom-time">{{item.release_date}}</div>
                                    <div class="right-bottom-tips color1">{{lanType==1?'查看详情':'View details'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="phone-row row hidden-md hidden-lg" v-if="isShowWeb">
                <!--  web端  -->
                <div class="phone-center-list" v-if="sfsList.length">
                    <div class="center-list-top">{{lanType==1?'可持续燃料':'Sustainable Fuels'}}</div>

                    <div class="phoneCarbon-leg-center" @click="goMechanism(item)" v-for="(item,index) in sfsList" :key="index" v-if="index<4">
                        <div class="leg-center-top">
                            <img :src='item.picStr' alt="#" class="leg-center-img" />
                            <div class="info-list-layer">
                                <div class="list-layer-li bg1" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                                <div class="list-layer-li bg2" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                            </div>
                        </div>
                        <div class="leg-center-bottom">
                            <div class="center-bottom-title">{{lanType==1?item.title:item.titleEn}}</div>
                            <div class="center-bottom-bottom spaceBetween">
                                <div class="bottom-bottom-left">{{item.release_date}}</div>
                                <div class="bottom-bottom-right color1">{{lanType==1?'查看详情':'View details'}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="center-list-bottom middle" v-if="sfsList.length>4">
                        <div class="list-bottom-btn middle bg4" @click="goDynamicList(4)">{{lanType==1 ? '查看更多' : 'See more'}}</div>
                    </div>
                </div>

                <div class="phone-center-list" v-if="csList.length">
                    <div class="center-list-top">{{lanType==1?'气候创行者':'Climate Solver'}}</div>

                    <div class="phoneCarbon-leg-center" @click="goMechanism(item)" v-for="(item,index) in csList" :key="index" v-if="index<4">
                        <div class="leg-center-top">
                            <img :src='item.picStr' alt="#" class="leg-center-img" />
                            <div class="info-list-layer">
                                <div class="list-layer-li bg1" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                                <div class="list-layer-li bg2" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                            </div>
                        </div>
                        <div class="leg-center-bottom">
                            <div class="center-bottom-title">{{lanType==1?item.title:item.titleEn}}</div>
                            <div class="center-bottom-bottom spaceBetween">
                                <div class="bottom-bottom-left">{{item.release_date}}</div>
                                <div class="bottom-bottom-right color1">{{lanType==1?'查看详情':'View details'}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="center-list-bottom middle" v-if="csList.length>4">
                        <div class="list-bottom-btn middle bg3" @click="goDynamicList(3)">{{lanType==1 ? '查看更多' : 'See more'}}</div>
                    </div>
                </div>

                <div class="phone-center-list" v-if="sbtiList.length">
                    <div class="center-list-top">{{lanType==1?'SBTi科学碳目标':'Science Based Target initiative (SBTi)'}}</div>

                    <div class="phoneCarbon-leg-center" @click="goMechanism(item)" v-for="(item,index) in sbtiList" :key="index" v-if="index<4">
                        <div class="leg-center-top">
                            <img :src='item.picStr' alt="#" class="leg-center-img" />
                            <div class="info-list-layer">
                                <div class="list-layer-li bg1" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                                <div class="list-layer-li bg2" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                            </div>
                        </div>
                        <div class="leg-center-bottom">
                            <div class="center-bottom-title">{{lanType==1?item.title:item.titleEn}}</div>
                            <div class="center-bottom-bottom spaceBetween">
                                <div class="bottom-bottom-left">{{item.release_date}}</div>
                                <div class="bottom-bottom-right color1">{{lanType==1?'查看详情':'View details'}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="center-list-bottom middle" v-if="sbtiList.length>4">
                        <div class="list-bottom-btn middle bg1" @click="goDynamicList(1)">{{lanType==1 ? '查看更多' : 'See more'}}</div>
                    </div>
                </div>

                <div class="phone-center-list" v-if="rebpList.length">
                    <div class="center-list-top">{{lanType==1?'绿色电力需求':"Renewable Energy Buyers' Principles"}}</div>

                    <div class="phoneCarbon-leg-center" @click="goMechanism(item)" v-for="(item,index) in rebpList" :key="index" v-if="index<4">
                        <div class="leg-center-top">
                            <img :src='item.picStr' alt="#" class="leg-center-img" />
                            <div class="info-list-layer">
                                <div class="list-layer-li bg1" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                                <div class="list-layer-li bg2" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                            </div>
                        </div>
                        <div class="leg-center-bottom">
                            <div class="center-bottom-title">{{lanType==1?item.title:item.titleEn}}</div>
                            <div class="center-bottom-bottom spaceBetween">
                                <div class="bottom-bottom-left">{{item.release_date}}</div>
                                <div class="bottom-bottom-right color1">{{lanType==1?'查看详情':'View details'}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="center-list-bottom middle" v-if="rebpList.length>4">
                        <div class="list-bottom-btn middle bg2" @click="goDynamicList(2)">{{lanType==1 ? '查看更多' : 'See more'}}</div>
                    </div>
                </div>
            </div>
        </div>

        <footerBar ref="footerView"></footerBar>
    </div>
</template>
  
<script>
  import tab from '@/components/tab';
  import footerBar from '@/components/footerBar';
  import axios from 'axios';
  import { chunkArr,format } from '@/utils/util';
  import config from '@/utils/config';
  import { setTimeout } from 'timers';
  export default {
    name: 'activity',
    components: {
      tab:tab,
      footerBar:footerBar
    },
    data () {
      return {
        page:1,
        per_page:9,
        pageList:[],
        total:0,
        totalList:[],
        totalIndex:0,
        totalFor:[],
        projectId:0,
        isShowWeb:config.urlList.isShowWeb,
        lanType:1,
        sbtiList: [],
        rebpList: [],
        csList: [],
        sfsList: [],
        pageUrl: config.urlList,
        pageInfo: {}
      }
    },
    methods:{
      fatherMethod(type){
        const vm=this
        vm.lanType=type
        setTimeout(()=>{
          vm.$refs.footerView.choiceType(type);
        },400)
      },
      choiceProjectId(num){
        const vm=this
        vm.projectId=num;
        vm.page=1;
        vm.per_page=9;
        vm.queryCampaign();
      },
      queryCampaign(type){
        const vm=this
        axios.post(
          `${config.urlList.queryUrl}/api/cbh/news_list`,
          {
            type: 1,
            is_recommend: 0,
            project_id: type,
            page: 1,
            per_page: 10
          },
        ).then(res => {
          if(res.data.code==1){
            res.data.data.data.forEach(da=>{
              da.title_subEn = da.title_subEn?da.title_subEn:da.title_sub
              da.title_supEn = da.title_supEn?da.title_supEn:da.title_sup
              da.titleEn = da.titleEn?da.titleEn:da.title
              da.briefEn = da.briefEn?da.briefEn:da.brief
              da.picStr=`${config.urlList.imgUrl}${da.pic}`;
              da.updated_at=format(new Date(da.updated_at),'YYYY-MM-DD')
            })
            if(type === 1) {
                vm.sbtiList = res.data.data.data
            } else if(type === 2){
                vm.rebpList = res.data.data.data
            } else if(type === 3){
                vm.csList = res.data.data.data
            } else {
              vm.sfsList = res.data.data.data
            }
          }else{
            alert("网络请求错误，请稍后再试！")
          }
        })
      },
      choicePage(num){
        const vm=this
        vm.page=num;
        vm.queryCampaign();
      },
      upPage(){
        const vm=this;
        if(vm.totalIndex>0){
          vm.totalIndex--
        }
      },
      downPage(){
        const vm=this;
        if(vm.totalIndex<vm.totalList.length-1){
          vm.totalIndex++
        }
        //vm.queryCampaign();
      },
      moreBtn(){
        const vm=this
        if(vm.total>vm.per_page){
          vm.per_page+=9;
          vm.queryCampaign()
        }
      },
      goMechanism(item){
        const vm=this
        vm.$router.push({ path:'/mechanism',query:{id:item.id,type:1}})
      },
      goDynamicList(type){
        const vm=this
        vm.$router.push({ path:'/dynamicList',query:{type}})
      },
      queryPageInfo(){
        const vm=this;
        axios.get(
        `${config.urlList.queryUrl}/api/cbh/page/2`,
        ).then(res => {
          if(res.data.code==1){
            vm.pageInfo = res.data.data;
          }
        })
      },
    },
    created () {
      const vm = this;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    mounted(){
      const vm=this
      vm.queryCampaign(1)
      vm.queryCampaign(2)
      vm.queryCampaign(3)
      vm.queryCampaign(4)
      vm.queryPageInfo()
    }
  }
</script>
<style scoped>
  /**  pc banner图  **/
  .activity-top{
    width: 100%;
    height: 4.0625rem;
    position: relative;
  }
  .inner-item-img{
    width: 100%;
    height: 100%;
  }
  .activity-top-font{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .top-font-font{
    font-size: 0.45rem;
    color: #fff;
    font-family: 'wwf';
  }
  /**  web Banner图  **/
  .phone-activity-top{
    width: 100%;
    height: 8rem;
    position: relative;
  }
  .phone-inner-img{
    width: 100%;
    height: 100%;
  }
  .phone-font-font{
    font-size: 0.8rem;
    color: #fff;
  }

  /**  pc端 列表  **/
  .dynamic-center-list{
    width: 100%;
    height: auto;
    padding: 0.375rem 0.5rem 0.537rem;
    background-color: #fff;
  }
  .dynamic-center-list:nth-child(2n){
    background-color: #f7f7f8;
  }
  .center-list-top{
    width: 100%;
    height: auto;
  }
  .list-top-left{
    font-size: 0.281rem;
    font-family: 'wwf';
  }
  .top-left-label{
    width: 0.063rem;
    height: 0.25rem;
    margin-right: 0.15rem;
  }
  .top-right-btn{
    width: 0.94rem;
    height: 0.312rem;
    cursor: pointer;
  }
  .right-btn-font{
    font-size: 0.125rem;
    font-family: 'wwf';
    color: #fff;
  }
  .right-btn-icon{
    width: 0.125rem;
    height: auto;
    margin-left: 0.05rem;
  }
  .center-list-center{
    margin-top: 0.262rem;
    width: 100%;
    height: auto;
  }
  .list-center-li{
    width: 49.5%;
    height: auto;
    box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
    margin-bottom: 0.131rem;
    cursor: pointer;
  }
  .center-li-left{
    width: auto;
    height: auto;
    position: relative;
  }
  .li-left-btns{
    position: absolute;
    bottom: 0.125rem;
    left: 0.03rem;
    right: 0.03rem;
  }
  .center-li-img{
    width: 1.875rem;
    height: 1.25rem;
    object-fit: cover;
  }
  .left-btns-btn{
    padding: 0.0625rem 0.0875rem;
    font-size: 0.0875rem;
    color: #fff;
    line-height: 1;
    margin: 0 0.03rem;
  }
  .center-li-right{
    flex: 2;
    height: 1.25rem;
    padding: 0.1875rem 0.1875rem 0.1625rem 0.225rem;
  }
  .li-right-title{
    font-size: 0.125rem;
    line-height: 1.5;
    font-family: 'wwf';
    text-align: left;
  }
  .li-right-bottom{
    width: 100%;
  }
  .right-bottom-time{
    font-size: 0.1125rem;
    color: #999999;
  }
  .right-bottom-tips{
    font-size: 0.1125rem;
  }

  /**  WEB端 列表  **/
  .phone-center-list{
    padding: 0.5rem;
    height: auto;
  }
  .center-list-top{
    font-size: 0.42rem;
    color: #333333;
    font-weight: 600;
    text-align: center;
    margin-bottom: 0.25rem;
  }
  .phoneCarbon-leg-center {
    margin-top: 0.48rem;
    width: 100%;
    height: auto;
    box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-bottom: 0.45rem;
  }
  .leg-center-top{
    width: 100%;
    height: auto;
    position: relative;
  }
  .leg-center-img {
    width: 100%;
    height: auto;
    border-radius: 6px 6px 0 0;
  }
  .info-list-layer{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }
  .list-layer-li{
    margin-bottom: 0.125rem;
    padding: 6px 10px;
    font-size: 0.25rem;
    color: #fff;
    background: #32a5cf;
    margin-right: 0.15rem;
    display: inline-block;
    line-height: 1;
  }
  .list-layer-li:nth-child(1){
    margin-left: 0.25rem;
  }
  .leg-center-bottom {
    padding: 0.42rem 0.24rem;
    height: auto;
    background: #fff;
    border-radius: 0 0 6px 6px;
  }
  .center-bottom-title {
    font-size: 0.48rem;
    color: #000;
    font-family: 'wwf';
    line-height: 1.4;
    margin-bottom: 0.32rem;
    text-align: left;
  }
  .center-bottom-bottom{
    padding-top: 0.28rem;
    width: 100%;
    height: auto;
  }
  .bottom-bottom-left,.bottom-bottom-right{
    font-size: 0.32rem;
    color: #999;
  }
  .center-list-bottom{
    padding-top: 0.32rem;
    margin-bottom: 0.32rem;
    height: auto;
    width: 100%;
  }
  .list-bottom-btn{
    width: 4rem;
    height: 1.067rem;
    font-size: .4rem;
    color: #fff;
    margin: 0 auto .5rem;
  }

  


  .bg1{
    background-color: #a08ac0;
  }
  .bg2{
    background-color: #74b9a0;
  }
  .bg3{
    background-color: #f1ad61;
  }
  .bg4{
    background-color: #0286e3;
  }
  .color1{
    color: #a08ac0;
  }
</style>
  
  
